import {IconProps} from "types/types";

export default function CloseRoundIcon({size=30,...props}:IconProps) {
    return <svg width={size} height={size} {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="30" height="30" rx="15" fill="#F9F9F9"/>
        <path d="M10.7574 10.7573L19.2426 19.2426" stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M19.2426 10.7573L10.7574 19.2426" stroke="#6E6E6E" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>

}